export default function create_readable_id(size) {
  let idSize = (size || 4) + 2;
  return (Math.random() + 1).toString(36).slice(2, idSize);
}
